import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Invoices")
], -1)
const _hoisted_4 = { class: "col-auto q-gutter-md" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Show invoice")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Show agreement")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Show external logs")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_invoices_filter = _resolveComponent("invoices-filter")!
  const _component_uuid = _resolveComponent("uuid")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_invoices_show_invoice = _resolveComponent("invoices-show-invoice")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isInvoicingManager)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              label: "Create all eligible invoices",
              color: "primary",
              disabled: _ctx.invoiceCreationInProgress,
              onClick: _ctx.onCreateInvoices,
              unelevated: "",
              "no-caps": ""
            }, null, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_q_btn, {
          label: "Reset filters",
          color: "primary",
          onClick: _ctx.onResetFilters,
          outline: "",
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_invoices_filter, {
      modelValue: _ctx.filter,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_q_table, {
      columns: _ctx.invoicesColumns,
      rows: _ctx.invoices,
      "row-key": "invoiceId",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
      filter: _ctx.filter,
      onRequest: _ctx.onRequest,
      loading: _ctx.loading,
      flat: "",
      class: "sticky-actions-column"
    }, {
      "body-cell-invoiceId": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_uuid, {
              id: props.value
            }, null, 8, ["id"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-status": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_badge, {
              color: _ctx.getInvoiceStatusColors(props.value),
              label: props.value
            }, null, 8, ["color", "label"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onShowInvoiceRow(null, props.row)),
              icon: "pageview"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onShowAgreement(props.row)),
              icon: "receipt"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (_ctx.isInvoicingManager)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  dense: "",
                  round: "",
                  flat: "",
                  color: "grey",
                  onClick: ($event: any) => (_ctx.onShowExternalLogs(props.row)),
                  icon: "book"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "filter", "onRequest", "loading"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showInvoice,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showInvoice) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_invoices_show_invoice, {
          invoice: _ctx.currentInvoice,
          updateCallback: _ctx.onHideInvoiceView
        }, null, 8, ["invoice", "updateCallback"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}